import React from 'react';
import './Layout.css';
import Navbar from '../Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';

const Layout = () => {


  return (
    <div className="layout">
      {/* Navbar */}
      <Navbar/>

      {/* Main Wrapper */}

        {/* Main Content */}
        <main>
          <Outlet/>
        </main>
     
     <Footer/>
      </div>
      
  );
};

export default Layout;
